enum FirmwareUpgradeState {
  Unknown = 'UNKNOWN',
  Available = 'AVAILABLE',
  Busy = 'BUSY',
  Planned = 'PLANNED',
  Completed = 'COMPLETED'
}

export default FirmwareUpgradeState;
